import { Helmet } from 'react-helmet-async';
// @mui
import { alpha } from '@mui/material/styles';
import { Grid, Button, Container, Stack, Chip } from '@mui/material';
import { useState, useEffect } from 'react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

import { GET_MODELS_URL } from '../utils/services';

// components
import { BlogPostCard, BlogPostsSearch } from '../sections/@dashboard/blog';
import JuicyAdsComponent from '../components/ads/JuicyAdsComponent';

// ----------------------------------------------------------------------

export default function LoifPage() {
  const DEFAULT_MODELS_SHOWN = 39;
  const [initialNames, setInitialNames] = useState([]);
  const [modelNames, setModelNames] = useState([]);
  const [indexShowing, setIndexShowing] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetch(GET_MODELS_URL)
      .then(res => res.json())
      .then(
        (result) => {
          if (result !== undefined) {
            console.debug(result);
            setModelNames(result);
            setInitialNames(result);
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }, []);

  const handleNext = () => {
    const calc = indexShowing + DEFAULT_MODELS_SHOWN;
    if (calc < modelNames.length) {
      setIndexShowing(calc);
      setCurrentPage(currentPage + 1);
      window.scrollTo(0, 0);
    }
  };

  const handlePrevious = () => {
    const calc = indexShowing - DEFAULT_MODELS_SHOWN;
    if (calc >= 0) {
      setIndexShowing(calc);
      setCurrentPage(currentPage - 1);
      window.scrollTo(0, 0);
    }
  };

  const handleSearch = (filterValue) => {
    if (filterValue === '') {
      setModelNames(initialNames);
    } else {
      const filteredNames = initialNames.filter((m) => m.folder_name.includes(filterValue));
      setModelNames(filteredNames);
    }
    setCurrentPage(1);
    setIndexShowing(0);
  };

  const handleSort = (sortOption) => {
    const names = [...initialNames];
    switch (sortOption) {
      case 'Shuffle':
        setModelNames(names.sort(() => Math.random() - 0.5));
        break;
      case 'A-Z':
        names.sort((a, b) => {
          const nameA = a.folder_name.toUpperCase();
          const nameB = b.folder_name.toUpperCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
        setModelNames(names);
        break;
      default:
        setModelNames(initialNames);
        break;
    }
  };

  const totalPages = Math.ceil(modelNames.length / DEFAULT_MODELS_SHOWN);

  return (
    <>
      <Helmet>
        <title> Lòi | Home </title>
      </Helmet>

      <Container sx={{ py: 4 }}>
        <Stack mb={4} direction="row" alignItems="center" justifyContent="space-between">
          <BlogPostsSearch
            posts={[...modelNames]}
            onSearch={handleSearch}
            onSort={handleSort}
            postsCount={initialNames.length}
          />
        </Stack>

        <JuicyAdsComponent />

        <Grid container spacing={2.5} sx={{ mt: 1 }}>
          {modelNames
            .slice(indexShowing, Math.min(indexShowing + DEFAULT_MODELS_SHOWN, modelNames.length))
            .map((model, index) => (
              <BlogPostCard
                key={index}
                post={model}
                index={index}
                cover={`https://loif-xxx.s3.amazonaws.com/models/${model.folder_name}/${model.cover}`}
              />
            ))}
        </Grid>

        {/* Pagination */}
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} mt={5} mb={3}>
          <Button
            variant="outlined"
            startIcon={<NavigateBeforeIcon />}
            onClick={handlePrevious}
            disabled={currentPage <= 1}
            sx={{ minWidth: 44, px: 1.5 }}
          />
          <Chip
            label={`${currentPage} / ${totalPages || 1}`}
            variant="outlined"
            sx={{
              fontWeight: 600,
              fontSize: '0.9rem',
              px: 1,
              borderRadius: 2,
              borderColor: (theme) => alpha(theme.palette.grey[500], 0.3),
            }}
          />
          <Button
            variant="outlined"
            endIcon={<NavigateNextIcon />}
            onClick={handleNext}
            disabled={currentPage >= totalPages}
            sx={{ minWidth: 44, px: 1.5 }}
          />
        </Stack>

        <JuicyAdsComponent />
      </Container>
    </>
  );
}
